<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <tag-form :create="true" @saved="editTag"></tag-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editTag(tag) {
                this.$router.push({name: 'tag', params: {id: tag.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// TagCreate.vue?fa5a1ad8